import { useEffect } from 'react';
import { TuvSudLogo } from '../components/ui/TuvSudLogo';
import { applyPageMeta } from '../lib/applyPageMeta';

const NAVY = '#0b253b';
const BLUE = '#0046AD';
const FONT = "'TUV SUD Pro', var(--ts-semantic-typography-font-family-default), Arial, sans-serif";

export function NotFoundPage() {
  useEffect(() => {
    applyPageMeta({
      title: 'Page not found | TÜV SÜD Academy',
      description: 'The page you are looking for does not exist.',
      themeColor: '#ffffff',
      ogImage: '',
      ogImageAlt: '',
      twitterCard: 'summary',
      robots: 'noindex,nofollow',
    });
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: '#fff',
        fontFamily: FONT,
        color: NAVY,
      }}
    >
      <header style={{ borderBottom: '1px solid rgba(11,37,59,0.1)' }}>
        <div
          style={{
            maxWidth: 1280,
            margin: '0 auto',
            padding: '20px 24px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <TuvSudLogo width={64} />
        </div>
      </header>

      <main
        style={{
          flex: 1,
          display: 'grid',
          placeItems: 'center',
          padding: '64px 24px',
        }}
      >
        <div style={{ textAlign: 'center', maxWidth: 560 }}>
          <div
            style={{
              fontSize: 120,
              fontWeight: 700,
              lineHeight: 1,
              color: BLUE,
              letterSpacing: '-0.02em',
            }}
          >
            404
          </div>
          <h1
            style={{
              fontSize: 32,
              fontWeight: 700,
              lineHeight: '40px',
              margin: '24px 0 0',
              color: NAVY,
            }}
          >
            Diese Seite wurde nicht gefunden
          </h1>
          <p
            style={{
              fontSize: 16,
              lineHeight: '24px',
              margin: '16px 0 0',
              color: 'rgba(11,37,59,0.7)',
            }}
          >
            Die angeforderte Seite existiert nicht oder ist nicht mehr verfügbar. Bitte überprüfen Sie die Adresse
            oder besuchen Sie die TÜV SÜD Akademie.
          </p>
          <div style={{ marginTop: 40 }}>
            <a
              href="https://www.tuvsud.com/de-de/store/akademie"
              style={{
                background: BLUE,
                color: '#fff',
                padding: '17px 32px',
                borderRadius: 4,
                textDecoration: 'none',
                fontSize: 14,
                fontWeight: 500,
                lineHeight: '21px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              Zur TÜV SÜD Akademie
            </a>
          </div>
        </div>
      </main>

      <footer style={{ borderTop: '1px solid rgba(11,37,59,0.1)' }}>
        <div
          style={{
            maxWidth: 1280,
            margin: '0 auto',
            padding: '20px 24px',
            fontSize: 13,
            lineHeight: '20px',
            color: 'rgba(11,37,59,0.6)',
            display: 'flex',
            gap: 24,
            flexWrap: 'wrap',
            justifyContent: 'space-between',
          }}
        >
          <span>© {new Date().getFullYear()} TÜV SÜD</span>
          <span style={{ display: 'inline-flex', gap: 24 }}>
            <a
              href="https://www.tuvsud.com/de-de/impressum"
              style={{ color: 'rgba(11,37,59,0.6)', textDecoration: 'none' }}
            >
              Impressum
            </a>
            <a
              href="https://www.tuvsud.com/de-de/datenschutz"
              style={{ color: 'rgba(11,37,59,0.6)', textDecoration: 'none' }}
            >
              Datenschutz
            </a>
          </span>
        </div>
      </footer>
    </div>
  );
}
